
import { computed, defineComponent } from "vue-demi";
import { track } from "@amplitude/analytics-browser";
import { SMAdditionalInfo } from "@/store";
import { API_TDependant } from "@/models/dependant";

export default defineComponent({
  name: "PricingRequestsPopups",

  components: {
    BritishCitizenshipPopup: () =>
      import("@/modules/Pricing/Requests/Popups/BritishCitizenshipPopup.vue"),
    ILRPopup: () => import("@/modules/Pricing/Requests/Popups/ILRPopup.vue"),
    SWDependantVisaPopup: () =>
      import("@/modules/Pricing/Requests/Popups/SWDependantVisaPopup.vue"),
    SLPopup: () => import("@/modules/Pricing/Requests/Popups/SLPopup.vue"),
  },

  props: {
    dependantsList: { type: Array as () => API_TDependant[], default: () => [] },
  },

  setup() {
    const activeService = computed(() => SMAdditionalInfo.pricingRequestsActiveService);
    const currentStep = computed(() => SMAdditionalInfo.pricingRequestsCurrentStep);
    const showModal = computed(() => SMAdditionalInfo.pricingRequestsShowModal);

    function goToSuccess() {
      SMAdditionalInfo.setPricingRequestsCurrentStep("success");
    }

    function closeFlow() {
      if (currentStep.value === "success") {
        track("Clicked 'Submit Request'", { service: activeService.value });
      } else {
        track("Closed the modal", { service: activeService.value, step: currentStep.value });
      }

      SMAdditionalInfo.setPricingRequestsActiveService(null);
      SMAdditionalInfo.setPricingRequestsCurrentStep("intro");
      SMAdditionalInfo.setPricingRequestsShowModal(false);
    }

    return {
      activeService,
      currentStep,
      showModal,
      goToSuccess,
      closeFlow,
    };
  },
});
